import Preferences from './Preferences';
import { Helmet } from 'react-helmet';
import { PageTitles } from './pageTitle';
import { useTypedSelector } from 'src/reducers';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import { useSetCandidateId } from './hooks/useSetCandidateId';
import { useSetTrackingContext } from './tracking/tealium';
import { useEffect } from 'react';
import { useAnalytics } from 'src/contexts/AnalyticsContext';
import { useUserProfile } from './hooks/useUserProfile';

export const Notifications = () => {
  const brand = useTypedSelector((state) => state.page.pageAnalytics.brand);
  const { t } = useTranslations(translations);
  const { user } = useUserProfile();
  const { trackPageLoad } = useAnalytics();

  useEffect(() => {
    if (user) {
      trackPageLoad({ currentPage: 'notification settings' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]); // Disabling dependency on trackPageLoad to only track initial tab render

  useSetCandidateId();
  useSetTrackingContext();

  return (
    <>
      <Helmet>
        <title>{`${PageTitles[brand]} - ${t('preferences-page-title')}`}</title>
      </Helmet>
      <Preferences />
    </>
  );
};
